import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SortFields } from '../../../models/api/reports/sort-fields';
import { BaseComponent } from '../../base/base.component';
import { ColumnComponent } from '../../core/table/column.component';
import { TableComponent } from '../../core/table/table.component';

@Component({
  selector: 'app-sort-field-view',
  imports: [CommonModule, TableComponent, ColumnComponent],
  template: `
    <app-table
      [dataSource]="sortBreakFields"
      recordLabel="field"
      [stripedRows]="true"
      [showFilter]="true"
      [showFilterButton]="true"
      [showPaginator]="false"
    >
      <app-column name="sequence" label="Position" />
      <app-column name="sortColumn" label="Field" />
      <app-column name="sortOrder" label="Sort">
        <ng-template #value let-data>
          {{ data.sortOrder === 'ASC' ? 'Ascending' : 'Descending' }}
        </ng-template>
      </app-column>
      <app-column name="pageBreak" label="Page Break" format="b" />
    </app-table>
  `,
  styles: ``,
})
export class SortFieldViewComponent extends BaseComponent {
  @Input()
  sortBreakFields: SortFields[] = [];
}
